import type { RootState } from 'state';
import type { DataCountriesState } from '../slice';

function getDataCountries(state: RootState): DataCountriesState['value'] {
  const { value } = state.dataService.dataCountries;
  return value;
}

export default getDataCountries;
